import React from "react";
import { Form } from "react-bootstrap";
import { Guardian } from '@xaamin/guardian';

import { FormControl } from "../../../../facturotopia";

const PersonalizarObservaciones = (props) => {
  const { data } = props;

  const handleOnChange = (value) => {
    props.onChange(value);
  }

  return (
    <>
      { Guardian.allows('factura_observaciones.access') && (
        <div>
          <Form autoComplete="off">
            <FormControl as="textarea"
              label="Observaciones"
              name="Observaciones"
              placeholder=""
              help=""
              row="3"
              value={ data.Observaciones }
              onChange={ handleOnChange }
            />
          </Form>
        </div>
      )}
    </>
  );
}

export default PersonalizarObservaciones;
